export enum AskAQuestionCategoryType {
	Unknown,
	Other,
	Support,
}
